import React, { useState } from "react";
import AdminPage from "../AdminPage";
import MyFormsPage from "../MyFormsPage";
import HomeMain from "../HomeMain/index";
import HomePageContainer from "../HomePageConatiner/HomePageContainer";
import ReportsContainer from "../ReportsContainer/ReportsContainer";
import MoodMeterReportContainer from "../MoodMeterReportContainer/MoodMeterReportContainer";
import ReportsCalendarContainer from "../ReportsCalendarContainer/ReportsCalendarContainer";
import ReportsCoachesContainer from "../ReportsCoachesContainer/ReportsCoachesContainer";
import ReportSurveyContainer from "../ReportSurveyContainer/ReportSurveyContainer";
import ReportsEngagementContainer from "../ReportsEngagementContainer/ReportsEngagementContainer";
import ReportsGamificationContainer from "../ReportsGamificationContainer/ReportsGamificationContainer";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import FillOutSurveyContainer from "../FillOutSurveyContainer/FillOutSurveyContainer";
import MyCoachesContainer from "../MyCoachesContainer/MyCoachesContainer";
import MyCalendarContainer from "../MyCalendarContainer/MyCalendarContainer";
import { unregister } from "../../Interceptor/Interceptor";
import AdminUsersContainer from "../AdminUsersContainer";
import FormCreationMain from "../FormCreationMainPage/FormCreationMain";
import { cookie, logOutApp } from "../../util/JWTCookie";
import Store from "../../Store/StoreBulkUpload";
import StoreQuestions from "../../Store/StoreQuestions";
import AgentPage from "../AgentPage/agentPage";
import MenuManagementContainer from "../MenuManagementContainer/MenuManagementContainer";
import UsersManagementContainer from "../UsersManagementContainer/UsersManagementContainer";
import InternalDataManagementContainer from "../InternalDataManagementContainer/InternalDataManagementContainer";
import EmailTemplateContainer from "../EmailTemplateContainer/EmailTemplateContainer";
import KnowledgeManagementContainer from "../KnowledgeManagementContainer/KnowledgeManagementContainer";
import PolicyInsightsContainer from "../PolicyInsightsContainer/PolicyInsightsContainer";
import MyGamesContainer from "../MyGamesContainer/MyGamesContainer";
import { useIdleTimer } from "react-idle-timer";
import PortalModal from "../../Portals";
import AlarmIcon from "@material-ui/icons/Alarm";
import { ContentInactivityTime, ButtonOk } from "./LayoutHome.styled";
import DetailReportsContainer from "../DetailReportsContainer/DetailReportsContainer";
import DetailEventsContainer from "../DetailEventsContainer/DetailEventsContainer";
import AdminEventsContainer from "../AdminEventsContainer/AdminEventsContainer";
import ActivitiesContainer from "../ActivitiesContainer/ActivitiesContainer";
import AdminPrivateGuestsContainer from "../AdminPrivateGuestsContainer/AdminPrivateGuestsContainer";
import AdminPublicGuestsContainer from "../AdminPublicGuestsContainer/AdminPublicGuestsContainer";
import CreateSpeakerContainer from "../CreateSpeakerContainer/CreateSpeakerContainer";
import AdminCategoryContainer from "../AdminCategoryContainer/AdminCategoryContainer";
import AdminCoachesContainer from "../AdminCoachesContainer/AdminCoachesContainer";
import CreateCoachContainer from "../CreateCoachContainer/CreateCoachContainer";
import YammerContainer from "../YammerContainer/YammerContainer";
import YammerCommunityContainer from "../YammerCommunityContainer/YammerCommunityContainer";
import YammerTopicContainer from "../YammerTopicContainer/YammerTopicContainer";
import MyCoachAvailabilityContainer from "../MyCoachAvailabilityContainer/MyCoachAvailabilityContainer";
import ManageEventContainer from "../ManageEventContainer/ManageEventContainer";
import MySpacesContainer from "../MySpacesContainer/MySpacesContainer";
import SpacesManagementContainer from "../SpacesManagementContainer/SpacesManagementContainer";
import CreateSpaceContainer from "../CreateSpaceContainer/CreateSpaceContainer";
import UpdateEmailTemplateContainer from "../UpdateEmailTemplateContainer/UpdateEmailTemplateContainer";
import DetailSpaceContainer from "../DetailSpaceContainer/DetailSpaceContainer";
import ModalLoader from "../../components/ModalLoader/ModalLoader";
import DetailGameContainer from "../DetailGameContainer/DetailGameContainer";
import GamesManagementContainer from "../GamesManagementContainer/GamesManagementContainer";
import CreateGameContainer from "../CreateGameContainer/CreateGameContainer";
import ResourcesContainer from "../ResourcesContainer/ResourcesContainer";
import PreviewFormContainer from "../PreviewFormContainer/PreviewFormContainer";
import FormsManagementContainer from "../FormsManagementContainer/FormsManagementContainer";
import NotifyContainer from "../NotifyContainer/NotifyContainer";
import MyInsightsContainer from "../MyInsightsContainer/MyInsightsContainer";
import MyInsightDetailContainer from "../MyInsightDetailContainer/MyInsightDetailContainer";
import MyCasesContainer from "../MyCasesContainer/MyCasesContainer";
import MyCaseDetailContainer from "../MyCaseDetailContainer/MyCaseDetailContainer";
import Chatbot from "../../components/Chatbot/Chatbot";
import SOSSettingsContainer from "../SOSSettingsContainer";
import MoodMeterSettings from "../../components/MoodMeterBlock/MoodMeterSettings/MoodMeterSettings";
import { withAITracking } from "@microsoft/applicationinsights-react-js";
import { ai } from "../../helpers/appInsights";
import CreatePolicyContainer from "../CreatePolicyContainer/CreatePolicyContainer";
import NewFormsManagement from "../../components/NewFormsManagement";
import ReportsICEContainer from "../ReportsICEContainer/ReportsICEContainer";
import ReportsPolicyInsightContainer from "../ReportsPolicyInsightContainer/ReportsPolicyInsightContainer";
import CoachEventsContainer from "../CoachEventsContainer/CoachEventsContainer";
import PropTypes from "prop-types";

export const LayoutHome = ({
  isAuthenticated,
  user,
  handleLogin,
  getAccessToken,
}) => {
  const [inactivityTime, setInactivityTime] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [menuList, setMenuList] = useState([]);

  const handleLogOut = () => {
    setShowLoader(true);
    logOutApp();
  };

  const handleOnIdle = (event) => {
    if (cookie.getRefreshToken("TrustSafety")) {
      setInactivityTime(true);
    }
  };

  const handleOnActive = (event) => {};

  const handleOnAction = (event) => {};
  const { getRemainingTime, getLastActiveTime } = useIdleTimer({
    timeout: 1000 * 60 * 60 * 8,
    onIdle: handleOnIdle,
    onActive: handleOnActive,
    onAction: handleOnAction,
    debounce: 0,
    crossTab: {
      emitOnAllTabs: true,
    },
  });

  return (
    <>
      <Store>
        <StoreQuestions>
          <BrowserRouter>
            <HomeMain
              handleLogOut={handleLogOut}
              isAuthenticated={isAuthenticated}
              userInfo={user}
              handleLogin={handleLogin}
              menuList={menuList}
              setMenuList={setMenuList}
            >
              <Switch>
                <Route
                  exact
                  path={["/", "/Home"]}
                  component={() => <HomePageContainer menuList={menuList} />}
                ></Route>
                <Route exact path="/ManageSurvey" component={AdminPage}></Route>
                <Route exact path="/Survey" component={AgentPage}></Route>
                <Route exact path="/Forms" component={MyFormsPage}></Route>
                <Route
                  exact
                  path="/FormsManagement"
                  component={NewFormsManagement}
                ></Route>
                <Route
                  exact
                  path="/PolicyFormsManagement"
                  component={FormsManagementContainer}
                ></Route>
                <Route
                  exact
                  path="/PreviewForm"
                  component={PreviewFormContainer}
                ></Route>
                <Route
                  exact
                  path="/MyCoaches"
                  component={MyCoachesContainer}
                ></Route>
                <Route
                  exact
                  path="/Reports"
                  component={ReportsContainer}
                ></Route>
                <Route
                  exact
                  path="/MoodMeterReport"
                  component={MoodMeterReportContainer}
                ></Route>
                <Route
                  exact
                  path="/CalendarReport"
                  component={ReportsCalendarContainer}
                ></Route>
                <Route
                  exact
                  path="/CoachesReport"
                  component={ReportsCoachesContainer}
                ></Route>
                <Route
                  exact
                  path="/EngagementReport"
                  component={ReportsEngagementContainer}
                ></Route>
                <Route
                  exact
                  path="/GamificationReport"
                  component={ReportsGamificationContainer}
                ></Route>
                <Route
                  exact
                  path="/ICEReport"
                  component={ReportsICEContainer}
                ></Route>
                <Route
                  exact
                  path="/PolicyInsightReport"
                  component={ReportsPolicyInsightContainer}
                ></Route>
                <Route
                  exact
                  path="/ManageEvent"
                  component={ManageEventContainer}
                />
                <Route
                  exact
                  path="/Activities"
                  component={ActivitiesContainer}
                />
                <Route
                  exact
                  path="/MySpaces"
                  component={MySpacesContainer}
                ></Route>
                <Route
                  exact
                  path="/DetailSpace"
                  component={DetailSpaceContainer}
                ></Route>
                <Route
                  exact
                  path="/DetailGame"
                  component={DetailGameContainer}
                ></Route>
                <Route
                  exact
                  path="/CreateSpace"
                  component={CreateSpaceContainer}
                ></Route>
                <Route
                  exact
                  path="/UpdateEmailTemplate"
                  component={UpdateEmailTemplateContainer}
                ></Route>
                <Route
                  exact
                  path="/CreateGame"
                  component={CreateGameContainer}
                ></Route>
                <Route
                  exact
                  path="/CreatePolicy"
                  component={CreatePolicyContainer}
                ></Route>
                <Route
                  exact
                  path="/SpacesManagement"
                  component={SpacesManagementContainer}
                ></Route>
                <Route
                  exact
                  path="/GamesManagement"
                  component={GamesManagementContainer}
                ></Route>
                <Route
                  exact
                  path="/DetailEvent"
                  component={DetailEventsContainer}
                ></Route>
                <Route
                  exact
                  path="/DetailReports"
                  component={DetailReportsContainer}
                ></Route>
                <Route
                  exact
                  path="/MyCoachAvailability"
                  component={MyCoachAvailabilityContainer}
                ></Route>
                <Route
                  exact
                  path="/FillOutSurvey"
                  component={FillOutSurveyContainer}
                ></Route>
                <Route
                  exact
                  path="/UsersList"
                  component={AdminUsersContainer}
                ></Route>
                <Route
                  exact
                  path="/KnowledgeManagement"
                  component={KnowledgeManagementContainer}
                ></Route>
                <Route
                  exact
                  path="/PolicyInsights"
                  component={PolicyInsightsContainer}
                ></Route>
                <Route
                  exact
                  path="/ReportSurvey"
                  component={ReportSurveyContainer}
                ></Route>
                <Route
                  exact
                  path="/MyCalendar"
                  component={MyCalendarContainer}
                ></Route>
                <Route
                  exact
                  path="/EventManager"
                  component={AdminEventsContainer}
                ></Route>
                <Route
                  exact
                  path="/AdminPrivateGuestsContainer"
                  component={AdminPrivateGuestsContainer}
                ></Route>
                <Route
                  exact
                  path="/AdminPublicGuestsContainer"
                  component={AdminPublicGuestsContainer}
                ></Route>
                <Route
                  exact
                  path="/CreateSpeaker"
                  component={CreateSpeakerContainer}
                ></Route>
                <Route
                  exact
                  path="/AdminCategory"
                  component={AdminCategoryContainer}
                ></Route>
                <Route
                  exact
                  path="/CoachesManagement"
                  component={AdminCoachesContainer}
                ></Route>
                <Route
                  exact
                  path="/CreateCoach"
                  component={CreateCoachContainer}
                ></Route>
                <Route exact path="/Yammer" component={YammerContainer}></Route>
                <Route
                  exact
                  path="/YammerCommunity"
                  component={YammerCommunityContainer}
                ></Route>
                <Route
                  exact
                  path="/YammerTopic"
                  component={YammerTopicContainer}
                ></Route>
                <Route
                  exact
                  path="/MyGames"
                  component={MyGamesContainer}
                ></Route>
                <Route
                  exact
                  path="/Resources"
                  component={ResourcesContainer}
                ></Route>
                <Route exact path="/CreateForm" component={FormCreationMain} />
                <Route
                  exact
                  path="/Notify"
                  component={() => <NotifyContainer getAccessToken={getAccessToken} />}
                ></Route>
                <Route
                  exact
                  path="/MyInsights"
                  component={MyInsightsContainer}
                ></Route>
                <Route
                  exact
                  path="/MyCases"
                  component={MyCasesContainer}
                ></Route>
                <Route
                  exact
                  path="/MyInsightDetail"
                  component={MyInsightDetailContainer}
                ></Route>
                <Route
                  exact
                  path="/MyCaseDetail"
                  component={MyCaseDetailContainer}
                ></Route>
                <Route
                  exact
                  path="/ICESettings"
                  component={SOSSettingsContainer}
                ></Route>
                <Route
                  exact
                  path="/MenuManagement"
                  component={MenuManagementContainer}
                ></Route>
                <Route
                  exact
                  path="/UsersManagement"
                  component={UsersManagementContainer}
                ></Route>
                <Route
                  exact
                  path="/InternalDataManagement"
                  component={InternalDataManagementContainer}
                ></Route>
                <Route
                  exact
                  path="/EmailTemplates"
                  component={EmailTemplateContainer}
                ></Route>
                <Route exact path="/Chatbot" component={Chatbot}></Route>
                <Route
                  exact
                  path="/MoodMeterSettings"
                  component={MoodMeterSettings}
                ></Route>
                <Route
                  exact
                  path="/CoachEvents"
                  component={CoachEventsContainer}
                ></Route>
                <Route exact path="*" component={HomePageContainer}></Route>
              </Switch>
            </HomeMain>
          </BrowserRouter>
        </StoreQuestions>
      </Store>
      {inactivityTime && (
        <PortalModal>
          <ContentInactivityTime>
            <AlarmIcon></AlarmIcon>
            <label>
              Your session has been terminated due to inactivity, please login
              back again.
            </label>
            <div>
              <ButtonOk onClick={() => handleLogOut()}>Ok</ButtonOk>
            </div>
          </ContentInactivityTime>
        </PortalModal>
      )}

      {showLoader && <ModalLoader></ModalLoader>}
    </>
  );
};

export default withAITracking(ai.reactPlugin, LayoutHome);

LayoutHome.propTypes = {
  isAuthenticated: PropTypes.bool,
  user: PropTypes.object,
  handleLogin: PropTypes.func,
  getAccessToken: PropTypes.func,
}


